// Default group names
export const DEFAULT_USER_GROUP = 'Default Group';
export const DEFAULT_CHARGE_POINT_GROUP = 'Default Group';

export const DEFAULT_SPOT_USER_GROUP = 'Default Spot Group';

// Default download file
export const EMAIL_LIST_EXAMPLE_URL =
  'https://s3.amazonaws.com/app.evx.cl/static/templates/email-list-example.csv'; // TODO: Change this url
export const EMAIL_LIST_EXAMPLE_NAME = 'email-list-example.csv'; // TODO: Change this name
